import { useEffect } from "react";
import { useRouter } from "@tanstack/react-router";
import { trackMetaPageView } from "@/lib/meta-pixel";

/**
 * Fires exactly one Meta Pixel PageView per client-side route change.
 * The initial page view is already fired by the inline bootstrap in
 * __root head(), so this only fires when the resolved URL actually changes.
 */
export function MetaPixelTracker() {
  const router = useRouter();

  useEffect(() => {
    let lastUrl = window.location.href;
    const unsubscribe = router.subscribe("onResolved", ({ toLocation }) => {
      const url = toLocation.href;
      if (url === lastUrl) return;
      lastUrl = url;
      trackMetaPageView();
    });
    return unsubscribe;
  }, [router]);

  return null;
}
